<template>
	<h2 class="title-post">
		<div class="data">
			<div class="dia">{{dia}}</div>
			<div class="mes">{{mes}}</div>
		</div>
		<div class="title"><slot></slot></div>
	</h2>
</template>

<script>
export default{
	name: 'PostTitle',
	props: ['dia','mes', 'title']
}
</script>>


// WEBPACK FOOTER //
// src/assets/vue/components/Post/PostTitle.vue